<template>
  <template v-if="attribute">
    <component ref="elem" :class="[...vm.cssClasses(), statusError(), highlight]" class="formfield" :is="formFieldComponent()" :attribute="attribute"
      :isReadOnly="vm.isReadOnly.value" :format="format" :title="errorMessage()" :style="vm.isReadOnly.value ? null : vm.inputStyle"
      :data-hy-id="attribute.dataElement.id.value" :options="getOpts()" v-bind="{...$attrs, ...vm.debugAttributes()}" />
    <template v-if="!hideLog && attribute.metadata.tagValueByName('Logging') && !attribute.dataElement.isNew.value">
      <AenderungshistorieButton :attribute="attribute" :hasPager="historyHasPager()"/>
    </template>
  </template>
  <template v-else>
    -
  </template>
</template>

<script>

import ReadOnlyAnalyzer from "../../xmlrdb-metadata/ReadOnlyAnalyzer"
import Attribute from "../../xmlrdb-data/Attribute"
import formFieldVM from "./formFieldVM"
import { defineAsyncComponent, ref, watch, watchEffect } from "vue";
import { validationGroupProvInjFactory } from "../validation/ValidationGroup";
import scrollIntoView from "scroll-into-view-if-needed";
import sleep from "../../utils/sleep";

const AenderungshistorieButton = defineAsyncComponent(() => import("./AenderungshistorieButton.vue"));

export default {
  components: {
    AenderungshistorieButton,
  },
  inheritAttrs: false,
  props: {
    attribute: Attribute,
    readOnlyAnalyzer: {
      type: [ReadOnlyAnalyzer, Function, Boolean],
      default: undefined
    },
    format: { required: false, default: undefined },
    component: Object,
    errorIdentifier: [Array, String],
    hideLog: Boolean
  },
  
  setup(props) {
    const vm = formFieldVM(props);
    const grp = validationGroupProvInjFactory();

    function getOpts() {
      const opts = props.attribute.metadata.tagValueByName("FieldComponentOpts");
      if (!opts) return;
      try {
        return new Map(JSON.parse(opts));
      }
      catch (e) {
        console.error("Fehler beim Parsen von Opts", props.attribute.metadata.element().name() ,props.attribute.metadata.name(), opts, e);
      }
    }
    
    watchEffect(() => {
      if (vm.isReadOnly.value) {
        grp.errorIdentifier.value = [];
        return;
      }
      grp.errorIdentifier.value = vm.querySelectors();
      if (typeof props.errorIdentifier === "string") {
        grp.errorIdentifier.value.push(props.errorIdentifier)
      }
      else if(props.errorIdentifier) {
        grp.errorIdentifier.value.push(...props.errorIdentifier)
      }
    });
    
    const elem = ref();
    const highlight = ref();
    
    function scrollToGroup() {
      let el;
      if (!(elem.value.$el instanceof Element)) {
        el = elem.value.$el.nextElementSibling;
      }
      else {
        el = elem.value.$el;
      }
      scrollIntoView(el, {
        scrollMode: 'if-needed',
        block: 'center',
        inline: 'center',
        behavior: "smooth"
      })

      highlight.value = "HIGHTLIGHT_FIELD";
      sleep(3000).then( () => { highlight.value = undefined})
    }

    function historyHasPager() {
      return props.attribute?.metadata.tagValueByName("historyHasPager") !== "false";
    }

    grp.callbacks.value = [scrollToGroup];
     // Liefert: isReadOnly,cssClasses
    return {
      elem,
      highlight,
      grp,
      historyHasPager,
      statusError() {
        if (grp.hasError.value) {
          return "STATUS_ERROR"
        }
        if (grp.hasWarning.value) {
          return "STATUS_WARNING"
        }
        return "";
      },
      errorMessage() {
        let message = grp.errors.value.map(e => e.text.value ).join("\n")
        if (vm.errorMessages() && vm.errorMessages().length) {
          if (message && message.length) {
            message += "\n";
          }
          message += vm.errorMessages();
        }
        return message;
      },
      formFieldComponent() {
        return props.component ?? props.attribute.metadata.component();
      },
      getOpts,
      vm
    };
  }
}

</script>

<style>
.VALIDATION_ERROR {
  outline: 2px solid #ff474c;
  border-radius: 3px;
}
.STATUS_ERROR {
  outline: 2px solid #ff474c;
  border-radius: 3px;
}
.STATUS_WARNING, .VALIDATION_WARNING{
  outline: 2px solid #ffc800;
  border-radius: 3px;
}
.HIGHTLIGHT_FIELD {
  animation-name: fadebackground;
  animation-duration: 1s;
  animation-fill-mode:both ;
  animation-iteration-count: infinite;
}

.formfield {
  display: inline-block;
}

@keyframes fadebackground {
    from{ 
      outline-width: 2px;
    }
    to  { 
      outline-width: 10px;
      outline-color: rgba(0, 0, 0, 0)
    }
  }
</style>